/* eslint-disable no-restricted-syntax */
import { createApp } from 'vue'
import App from '@/fish/app.vue'
import router from '@/fish/router'
import storage from '@/plugins/storage'
import { fetchGlyphs } from '@/lib/glyphs'
import { initPerf } from '@/services/firebase-service'
import { provideVueAppUser } from '@/services/identity-vue-provider'
import { provideApolloClient } from '@/services/apollo-provider'
import { provideMapManager } from '@/services/map-provider'
import '@/styles/application-fish.scss'
import '@onxmaps/ys-tokens/all'
import '@xweather/mapsgl/dist/mapsgl.css'

import { createPinia } from 'pinia'
import { initSentry, makeSampler } from '@/lib/sentry'

import mapXIconShim from '@/components/map-x/map-x-icon-shim'

//setup pinia for fish
const pinia = createPinia()

// Init firebase and performance
initPerf()
const app = createApp(App)

// onX Guide errors bypass the 1% production sample rate so the feature's
// alert rules see real volume instead of a 1-in-100 shadow of it.
initSentry({ app, beforeSend: makeSampler(['ai-guide']) })

// Register map-x-icon under the same tag name the compiled code is looking for:
// eslint-disable-next-line vue/component-definition-name-casing
app.component('map-x-icon', mapXIconShim)

app.use(pinia)
app.use(router)
app.use(storage)
app.mount('#onx-fish-app')
provideVueAppUser(app)
provideApolloClient(app)
provideMapManager(app)
fetchGlyphs()
